import { AlertsJurisdictionModel } from "../models/alerts-jurisdiction";
import { AlertsJurisdictionView } from "./alerts-jurisdiction";
import { backboneViewProperties } from "../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "table",
    className: "alerts-jurisdictions-list",
    childView: AlertsJurisdictionView
})

export class AlertsJurisdictionListView extends Marionette.CollectionView<AlertsJurisdictionModel, AlertsJurisdictionView> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-jurisdiction-list.ts